import React from 'react';
import './TorrentHexagones.css';
import TorrentHexagone from "./TorrentHexagone/TorrentHexagone";

export default function TorrentHexagones({torrents, isDeletable, isShareable, isUserVisible}) {
    return <div className='TorrentHexagones'>{torrents.map((torrent) => <TorrentHexagone key={torrent._id} torrent={torrent} isShareable={isShareable} isDeletable={isDeletable} isUserVisible={isUserVisible} />)}</div>
}